export default __webpack_public_path__ + "static/media/Antoinette.8c93ab73.jpg";